import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate, Link, useLocation } from 'react-router-dom';
import { Row, Col, Form } from "react-bootstrap";
import { BsPencil, BsCheck, BsX } from "react-icons/bs";
import { Container, Card, Tabs, Tab, Button } from 'react-bootstrap';
import { BiPencil } from "react-icons/bi";
import { BsChevronLeft } from "react-icons/bs";
import LicenseModal from './LicenseModal';
import Swal from 'sweetalert2';

const LicenseView = () => {
    const { id } = useParams(); // Get the licenseId from the URL
    const [licenseDetails, setLicenseDetails] = useState(null);
    const [editedLicenseDetails, setEditedLicenseDetails] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [activeTab, setActiveTab] = useState('licenseDetails'); // Define activeTab
    const navigate = useNavigate();
    const location = useLocation();
    const [editField, setEditField] = useState(null);
    const [licenses, setLicenses] = useState([]);

    const [extensionDetails, setExtensionDetails] = useState([]);
    const queryParams = new URLSearchParams(location.search);
    const initialTab = queryParams.get("activeTab") || "licenseDetails"; // Default tab
    const [selectedLIC, setSelectedLIC] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const fetchLicenseDetails = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/licenses/${id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            const data = response.data.data;

            // Ensure all numerical fields default to 0
            const defaultValues = {
                s_admin: 0,
                admin: 0,
                supervisor: 0,
                team_lead: 0,
                analyst: 0,
                c_agent: 0,
                v_agent: 0,
                t_agent: 0,
                agent: 0,
                voicemail: 0,
                chat: 0,
                interaction: 0,
                voice: 0,
                api: 0,
              
                start_date: data.start_date || "",
                validity: data.validity || "",
                remarks: data.remarks || "",
            };
    
            const updatedData = { ...defaultValues, ...data };
    
            setLicenseDetails(updatedData);
            setEditedLicenseDetails(updatedData);


        } catch (error) {
            console.error('Error fetching license details:', error);
        }
    };
    const fetchExtensionDetails = async () => {

        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/licenses/${id}/extensions`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            setExtensionDetails(response.data.data);
        } catch (error) {
            console.error('Error fetching extension details:', error);
        }
    };
    const editLicense = async (licenseId, updatedData) => {
        try {
          const backendUrl = process.env.REACT_APP_BACKEND_URL;
      
          const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
          const token = userInfo?.token;
          const { extension_type, extension_days } = updatedData;
      
          // Only extend if extension type and value are provided
          if (extension_type && extension_days) {
            // Validate extension data (optional)
            if (
              !['days', 'weeks', 'months', 'years'].includes(extension_type) ||
              isNaN(extension_days) || extension_days < 1
            ) {
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'error',
                    title: 'Invalid extension data.',
                    timer: 3000,
                    timerProgressBar: false,
                    showConfirmButton: false,
                    didOpen: () => {
                      const container = Swal.getContainer();
                      container.style.top = '50px';
                    },
                  });             
                   return;
            }
      
            // Add extension data to the updatedData object
            updatedData.extension_type = extension_type;
            updatedData.extension_days = extension_days;
          }
          
          const response = await axios.put(`${backendUrl}/api/licenses/${licenseId}`, updatedData, {
            headers: {
              'Authorization': `Bearer ${token}`,
                'Tenant-Origin': origin,
            },
            params: {
              tenant_info_id: licenseDetails?.tenant_info_id, // Edit the license for this tenant
            },
          });
      
          const updatedLicense = response.data?.Data[0];
          if (updatedLicense) {
            updatedLicense.setup_name = updatedLicense.instance.setup_name;
      
            // Update isExtended flag based on extension data
            updatedLicense.isExtended = updatedLicense.extension_type !== null;
            setLicenseDetails((prevLead) => ({
                ...prevLead,
                ...updatedLicense, // Merge updated data
            }));
            setLicenses((prevLicenses) =>
              prevLicenses.map((license) =>
                license.id === updatedLicense.id ? updatedLicense : license
              )
            );
          } else {
            console.error('Update failed, no data returned.');
          }
      
          setShowModal(false);
        } catch (error) {
          console.error('Error updating license:', error);
        }
      };
    useEffect(() => {
        if (id) {
            fetchLicenseDetails();
        }
    }, [id]);

    // const handleChange = (e) => {
    //     const { name, value } = e.target;
    //     setEditedLicenseDetails((prevState) => ({
    //         ...prevState,
    //         [name]: value,
    //     }));
    // };

    const handleSave = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            await axios.put(`${backendUrl}/api/licenses/${id}`, editedLicenseDetails, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
            });

            setEditField(null);
        } catch (error) {
            console.error('Error saving license details:', error);
        }
    };
    // const calculateMaxLogin = (licenseDetails) => {
    //     if (!licenseDetails || typeof licenseDetails !== "object") {
    //         console.warn("licenseDetails is null or not an object:", licenseDetails);
    //         return 0;
    //     }

    //     return (
    //         (licenseDetails.s_admin || 0) +
    //         (licenseDetails.admin || 0) +
    //         (licenseDetails.supervisor || 0) +
    //         (licenseDetails.team_lead || 0) +
    //         (licenseDetails.analyst || 0) +
    //         (licenseDetails.c_agent || 0) +
    //         (licenseDetails.v_agent || 0) +
    //         (licenseDetails.t_agent || 0) +
    //         (licenseDetails.agent || 0)
    //     );
    // };

    // useEffect(() => {
    //     console.log("editedLicenseDetails:", editedLicenseDetails);

    //     if (!editedLicenseDetails) return;

    //     const newMaxLogin = calculateMaxLogin(editedLicenseDetails);
    //     const newMaxCreate = newMaxLogin * 3;

    //     setEditedLicenseDetails(prevState => ({
    //         ...prevState,
    //         max_login: newMaxLogin, 
    //         max_create: Math.min(prevState?.max_create || 0, newMaxCreate)
    //     }));
    // }, [editedLicenseDetails]);
    const calculateMaxLogin = (data) => {
        const fields = ['s_admin', 'admin', 'supervisor', 'team_lead', 'analyst', 'c_agent', 'v_agent', 't_agent', 'agent'];
        return fields.reduce((sum, field) => sum + (Number(data[field]) || 0), 0);
    };
    useEffect(() => {
        if (!editedLicenseDetails) return;

        const newMaxLogin = calculateMaxLogin(editedLicenseDetails);
        const newMaxCreate = newMaxLogin * 3;

        setEditedLicenseDetails(prevState => ({
            ...prevState,
            max_login: newMaxLogin,
            max_create: newMaxCreate,
        }));
    }, [
        editedLicenseDetails?.s_admin,
        editedLicenseDetails?.admin,
        editedLicenseDetails?.supervisor,
        editedLicenseDetails?.team_lead,
        editedLicenseDetails?.analyst,
        editedLicenseDetails?.c_agent,
        editedLicenseDetails?.v_agent,
        editedLicenseDetails?.t_agent,
        editedLicenseDetails?.agent
    ]);
    const handleChange = (e) => {
        const { name, value } = e.target;
        const updatedValues = {
            ...editedLicenseDetails,
            [name]: value, // Update the changed field
        };

        // Recalculate max_login and max_create if a relevant field is changed
        const relevantFields = [
            "s_admin",
            "admin",
            "supervisor",
            "team_lead",
            "analyst",
            "c_agent",
            "v_agent",
            "t_agent",
            "agent",
        ];

        if (relevantFields.includes(name)) {
            const newMaxLogin = calculateMaxLogin(updatedValues);
            const newMaxCreate = newMaxLogin * 3;
            updatedValues.max_login = newMaxLogin;
            // updatedValues.max_create = Math.min(updatedValues?.max_create || 0, newMaxCreate);
            if (updatedValues.max_create > newMaxCreate) {
                updatedValues.max_create = newMaxCreate;
            }
        }

        // If the user is editing max_create directly, prevent increasing it above max_login * 3
        if (name === "max_create") {
            const maxLimit = calculateMaxLogin(updatedValues) * 3;
            updatedValues.max_create = Math.min(Number(value), maxLimit); // Prevent exceeding limit
        }


        setEditedLicenseDetails(updatedValues);
    };


    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const activeTabParam = queryParams.get("activeTab") || "licenseDetails"; // Default to 'tenantInfo'
        setActiveTab(activeTabParam); // Set the active tab based on URL parameter
    }, [location.search]);

    const handleBackClick = () => {
        navigate(-1);
    };

    const handleTabClick = (tab) => {
        setActiveTab(tab);
        if (tab === 'extensionInfo') {
            // Fetch extension details only when tab is clicked
        }
        navigate(`${location.pathname}?activeTab=${tab}`);
    };

    if (!licenseDetails) {
        return <div>Loading...</div>;
    }
    const licenseFields = [
        { name: "s_admin", label: "S Admin", type: "number" },
        { name: "admin", label: "Admin", type: "number" },
        { name: "supervisor", label: "Supervisor", type: "number" },
        { name: "team_lead", label: "Team Lead", type: "number" },
        { name: "analyst", label: "Analyst", type: "number" },
        { name: "t_agent", label: "T agent", type: "number" },
        { name: "v_agent", label: "C agent", type: "number" },
        { name: "agent", label: "Agent", type: "number" },
        { name: "c_agent", label: "C agent", type: "number" },

        { name: "voicemail", label: "VoiceMail", type: "number" },
        { name: "chat", label: "Chat", type: "number" },
        { name: "interaction", label: "Interaction", type: "number" },
        { name: "voice", label: "Voice", type: "number" },
        { name: "api", label: "API", type: "number" },
        { name: "mobile_app", label: "Mobile App", type: "number" },
        { name: "max_login", label: "Max Login", type: "number", readOnly: true },
        { name: "max_create", label: "Max Create", type: "number" },
        { name: "start_date", label: "Start Date", type: "date" },
        { name: "validity", label: "Validity", type: "date" },
        { name: "remarks", label: "Remarks", type: "textarea" },
    ];

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-12 d-flex align-items-center">
                                    <BsChevronLeft
                                        className='back-button1'
                                        onClick={() => navigate(-1)}
                                    />
                                    <span>License</span>
                                </h4>
                                <div className="page-title-right br-font">
                                    <ol className="breadcrumb m-0">
                                        <li className="breadcrumb-item"><Link to={`/instance/details/${licenseDetails?.instance_id}`}>
                                            {licenseDetails?.instance?.setup_name || "Instane Details"}
                                        </Link></li>
                                        <li className="breadcrumb-item"><Link to={`/tenant/details/${licenseDetails?.tenant_info_id}`}>
                                            {licenseDetails?.tenant?.name || "Tenant Details"}
                                        </Link></li>
                                        {/* <li className="breadcrumb-item"><Link to={`/license/details/${id}`}>
                                                                            {licenseDetails?.tenant?.name|| "Tenant Details"}
                                                                        </Link></li> */}
                                        <li className="breadcrumb-item active">Details</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="p-6 max-w-7xl mx-auto">
                        <>
                            <Card className="mb-3 shadow-lg rounded-3 p-2 border-0 card-bg">
                                {/* Header Section with Name and Edit Icon */}
                                <div className="d-flex justify-content-between align-items-center">
                                    <Card.Title className="fw-bold  font-size-14  text-primary">{licenseDetails?.name || 'License Details'}</Card.Title>
                                    <BiPencil
                                        className="text-primary hover-effect2 edit-pencil"
                                        onClick={() => {
                                            setSelectedLIC(licenseDetails); // Store organisation details
                                            setShowModal(true); // Open modal
                                        }} />
                                </div>
                                <Card.Body className="pt-3">
                                    <div className="row">
                                        {/* Left Section */}
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <span className="text-muted d-block card-label"><strong>Start Date:</strong></span>
                                                <span className=" text-muted card-value">{licenseDetails?.start_date || '-'}</span>
                                            </div>
                                            <div className="mb-3">
                                                <span className="text-muted d-block card-label"><strong>Validity:</strong></span>
                                                <span className=" text-muted card-value">{licenseDetails?.validity || '-'}</span>
                                            </div>
                                        </div>

                                        {/* Right Section */}
                                        <div className="col-md-4">
                                            <div className="mb-3">
                                                <span className="text-muted d-block card-label"><strong>Remarks:</strong></span>
                                                <span className="fw-semibold text-primary card-value">{licenseDetails?.remarks || ''}</span>
                                            </div>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>

                            {showModal && (
                                <LicenseModal
                                    showModal={showModal}
                                    handleClose={() => setShowModal(false)}
                                    selectedLicenseData={selectedLIC} // Pass data here
                                    editLicense={editLicense}
                                   
                                    tenantId={selectedLIC?.tenant_info_id}
                                    selectedLicenseId={id}
                                />
                            )}
                        </>
                        <div className="row">
                            <div className="col-xl-12 col-lg-8">
                                <div className="card">
                                    {/* Nav tabs */}
                                    <ul className="nav nav-tabs nav-tabs-custom justify-content-start pt-2 font-size-13" role="tablist">

                                        <li className="nav-item">
                                            <a
                                                className={`nav-link ${activeTab === 'licenseDetails' ? 'active' : ''}`}
                                                onClick={() => setActiveTab('licenseDetails')}
                                                role="tab"
                                            >
                                                license Details
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a
                                                className={`nav-link ${activeTab === 'extensionInfo' ? 'active' : ''}`}
                                                onClick={() => {setActiveTab('extensionInfo');
                                                    fetchExtensionDetails();
                                                }} 
                                                role="tab"
                                            >
                                                Extension Details
                                            </a>
                                        </li>

                                    </ul>
                                    <div className="tab-content p-4">
                                        {activeTab === 'licenseDetails' && (
                                            <div className="p-3 font-size-13">
                                                <Row>
                                                    {licenseFields.map((field, index) => (
                                                        <Col md={6} key={index} className="mb-2 d-flex align-items-center ps-5">
                                                            <strong className="view-label">{field.label}:</strong>
                                                            <div className="editable-container d-flex align-items-center">
                                                                {editField === field.name ? (
                                                                    <div className="d-flex align-items-center">
                                                                        {field.type === "textarea" ? (
                                                                            <textarea
                                                                                name={field.name}
                                                                                value={editedLicenseDetails[field.name] || ""}
                                                                                onChange={handleChange}
                                                                                autoFocus

                                                                                className="form-control form-feild"
                                                                                />
                                                                        ) : (
                                                                            <Form.Control
                                                                                type={field.type}
                                                                                name={field.name}
                                                                                value={editedLicenseDetails[field.name] || ""}
                                                                                onChange={handleChange}
                                                                                autoFocus
                                                                                className="form-control form-feild"
                                                                                readOnly={field.readOnly}
                                                                            />
                                                                        )}
                                                                        <BsCheck className="text-success mx-2" onClick={handleSave} style={{ cursor: "pointer" }} />
                                                                        <BsX className="text-danger" onClick={() => setEditField(null)} style={{ cursor: "pointer" }} />
                                                                    </div>
                                                                ) : (
                                                                    <div className="hover1" onClick={() => !field.readOnly && setEditField(field.name)}>
                                                                        <span className="hover-field1">
                                                                            {editedLicenseDetails[field.name] || "-"}
                                                                        </span>
                                                                        {!field.readOnly && <BsPencil className="text-primary pencil-icon1" />}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </Col>
                                                    ))}
                                                </Row>
                                            </div>
                                        )}
                                        {activeTab === 'extensionInfo' && (
                                            <>
                                                <br />
                                                <table className="table table-hover datatable dt-responsive nowrap view-table font-size-13" >
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">#</th>
                                                            <th scope="col"> Date</th>

                                                            <th scope="col">Extended To</th>
                                                            <th scope="col">Validity</th> {/* Add column for new validity date */}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {extensionDetails.map((extension, index) => (
                                                            <tr key={extension.id}>
                                                                <td>{index + 1}</td>
                                                                <td>{new Date(
                                                                    extension.created_at
                                                                ).toLocaleDateString()}</td>

                                                                <td>{`${extension.extension_days} ${extension.extension_type}`}</td>
                                                                {/* <td>{extension.extension_days}</td> */}
                                                                <td>{extension.new_validity_date}</td> {/* Display the new validity date */}
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </>
                                        )}
                                    </div>
                                </div></div></div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default LicenseView;

